<c-card>
  <c-card-body>
    <!-- Header -->
    <optima-form-layout [layout]="formHeaderLayout"></optima-form-layout>
    
    <!-- Date Control -->
    @if (polyDateControl) {
      <div class="mb-3">
        <app-polymorphic-control [c]="polyDateControl"></app-polymorphic-control>
      </div>
    }

    <!-- Additional Fields -->
    <div class="additional-field-control">
    @for (ctrl of additionalFieldPolyControlMeta; track ctrl) {
    <app-polymorphic-control [c]="ctrl"></app-polymorphic-control>
    }
    </div>
    
    <!-- Footer Layout -->
    @if (!isInModal) {
      <optima-form-layout
        [layout]="formFooterLayout"
        (formDataChange)="onLogCreate()">
      </optima-form-layout>
    }
  </c-card-body>
</c-card>

